import React, { useState, useEffect, useCallback } from "react";
import Layout from "containers/LayoutV2";
import { pushNotification } from "utils/notifications";
import ConfigSystemApi from "service/QuanTriHeThong/CauHinhTinhLaiVaHeThong/ConfigSystemApi";
import { CauHinhCamDoTinChap } from "./Cauhinh/CauHinhCamDoTinChap";
import { CauHinhTraGop } from "./Cauhinh/CauHinhTraGop";
import { QuanLyPhiKhacModal } from "./QuanLyPhiKhac";
import "../../../assets/css/table-kydonglai.css";
import StoreApi from "service/phanQuyenApi";
import configsRole from "utils/configsRole";
import CauHinhApi from "../../../service/cauHinhApi";

const CustomCheckbox = ({
  id,
  name,
  checked,
  onChange,
  label,
  className = "",
}) => (
  <div className={`form-group ${className}`}>
    <label htmlFor={id} className="custom-control custom-checkbox">
      <input
        type="checkbox"
        id={id}
        name={name}
        checked={checked}
        onChange={onChange}
        className="custom-control-input"
      />
      <span className="custom-control-indicator"></span>
      <span className="custom-control-description">{label}</span>
    </label>
  </div>
);

const CustomRadio = ({
  id,
  name,
  value,
  checked,
  onChange,
  label,
  dataType,
  className = "",
}) => (
  <div className={`form-group ${className}`}>
    <label htmlFor={id} className="custom-control custom-radio">
      <input
        type="radio"
        id={id}
        name={name}
        value={value}
        data-type={dataType}
        checked={checked}
        onChange={onChange}
        className="custom-control-input"
      />
      <span className="custom-control-indicator"></span>
      <span className="custom-control-description">{label}</span>
    </label>
  </div>
);
export const CauHinhTinhLai = () => {
  const initPhanQuyen = {
    cauhinhtinhlai: false,
  };
  const [phanQuyen, setPhanQuyen] = useState(initPhanQuyen);
  const [loading, setLoading] = useState(true);
  const [isSaving, setIsSaving] = useState(false);
  const [IsSuDungPhiKhacHangKy, setSuDungPhiKhacHangKy] = useState(false);
  const initialConfigData = {
    CachTinhLai: 1,
    OptionTinhLai: 2,
    PhiKho: 2,
    IsTongSoNgay: false,
    NgayVayThemOption: 0,
    IsSoNgayTatToan: false,
    SoNgayMacDinhTatToan: 0,
    SuDungSoNgayMacDinhTatToan: false,
    IsGiaHanTuDong: false,
    KyDongLaiTinChapCamDo: "0",
    LaiSuatTinChapCamDoNgay: "0",
    LaiSuatTinChapCamDoTuan: "0",
    LaiSuatTinChapCamDoThang: "0",
    KyDongLaiNgayEnabled: false,
    KyDongLaiTuanEnabled: false,
    KyDongLaiThangEnabled: false,
    KyDongLaiThangDinhKyEnabled: false,
    KyDongLaiMacDinh: 0,
    LaiTrieuNgay_NgayEnabled: false,
    LaiNgay_NgayEnabled: false,
    LaiThang_NgayEnabled: false,
    LaiKy_NgayEnabled: false,
    LaiPhanTramKy_NgayEnabled: false,
    LaiSuatNgayMacDinh: 1,
    LaiTuan_TuanEnabled: false,
    LaiPhanTram_TuanEnabled: false,
    LaiSuatTuanMacDinh: 6,
    LaiTrieuNgay_ThangEnabled: false,
    LaiNgay_ThangEnabled: false,
    LaiThang_ThangEnabled: false,
    LaiSuatThangMacDinh: 1,
    AllBeforeAfterTinChapCamDo: false,
    BeforeAfterTinChapCamDo: 1,
    DuNoGiamDanTraGop: false,
    AllKyGopTraGop: false,
    AnDinhNgayThangTraGop: false,
    KhoangThoiGianTraGop: "0",
    KyGopTraGop: 1,
    AllTraThieuTraDuTraGop: false,
    TraThieuTraDu: 1,
    AllLaiTraGop: false,
    LaiTraGop: 1,
    AllBeforeAfterTraGop: false,
    BeforeAfterTraGop: 1,
    ChiPhiVayTraGop: 1,
  };
  const [configData, setConfigData] = useState(initialConfigData);
  const [activeTab, setActiveTab] = useState("camdo");
  const [modalState, setModalState] = useState({
    show: false,
    isPeriodic: false,
    loanType: 0,
    title: "",
  });

  const fetchConfiguration = useCallback(() => {
    setLoading(true);
    ConfigSystemApi.getCauHinhTinhLai()
      .then((res) => {
        if (res.status === 200) {
          //Dữ liệu cũ lưu ChiPhiVayTraGop = 0 cho "% Tháng", nay đổi mã sang 3.
          const data =
            res.data && res.data.ChiPhiVayTraGop === 0
              ? { ...res.data, ChiPhiVayTraGop: 3 }
              : res.data;
          setConfigData(data);
        } else pushNotification("Lấy dữ liệu cấu hình thất bại!", "error");
      })
      .catch(() => pushNotification("Lấy dữ liệu cấu hình thất bại!", "error"))
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    document.title = "Cấu hình tính lãi | Phần mềm quản lý cầm đồ Morman";
    LoadPhanQuyen();
    GetConfig();
  }, []);
  const GetConfig = () => {
    CauHinhApi.getConfigSys1().then((response) => {
      if (response.status === 200) {
        if (response.data.length > 0) {
          const SuDungPhiKhacHangKy = response.data.find(
            (e) => e.keyConfig === "SuDungPhiKhacHangKy"
          );
          if (SuDungPhiKhacHangKy != null) {
            if (SuDungPhiKhacHangKy.valueConfig === "1") {
              setSuDungPhiKhacHangKy(true);
            }
          }
        }
      }
    });
  };
  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    const isNumericRadio = e.target.dataset?.type === "number";
    const finalValue =
      type === "checkbox" ? checked : isNumericRadio ? Number(value) : value;
    setConfigData((prev) => ({
      ...prev,
      [name]: finalValue,
    }));
  };

  const handleSelectAll = (e) => {
    const isChecked = e.target.checked;
    setConfigData((prevData) => ({
      ...prevData,
      KyDongLaiNgayEnabled: isChecked,
      KyDongLaiTuanEnabled: isChecked,
      KyDongLaiThangEnabled: isChecked,
      KyDongLaiThangDinhKyEnabled: isChecked,
    }));
  };

  const handleSave = async () => {
    setIsSaving(true);
    let dataToSave = { ...configData };
    if (!dataToSave.KyDongLaiNgayEnabled) {
      dataToSave.LaiTrieuNgay_NgayEnabled = false;
      dataToSave.LaiNgay_NgayEnabled = false;
      dataToSave.LaiThang_NgayEnabled = false;
      dataToSave.LaiKy_NgayEnabled = false;
      dataToSave.LaiPhanTramKy_NgayEnabled = false;
    }
    if (!dataToSave.KyDongLaiTuanEnabled) {
      dataToSave.LaiTuan_TuanEnabled = false;
      dataToSave.LaiPhanTram_TuanEnabled = false;
    }
    if (!dataToSave.KyDongLaiThangEnabled) {
      dataToSave.LaiTrieuNgay_ThangEnabled = false;
      dataToSave.LaiNgay_ThangEnabled = false;
      dataToSave.LaiThang_ThangEnabled = false;
    }
    try {
      const res = await ConfigSystemApi.updateCauHinhTinhLai(dataToSave);
      if (res.status === 200) {
        pushNotification("Cập nhật cấu hình thành công!", "success");
      } else {
        pushNotification("Cập nhật thất bại!", "error");
      }
      fetchConfiguration();
    } catch {
      pushNotification("Cập nhật thất bại!", "error");
    } finally {
      setIsSaving(false);
    }
  };

  const showFeeModal = (isPeriodic, loanType, title) => {
    setModalState({ show: true, isPeriodic, loanType, title });
  };
  const LoadPhanQuyen = () => {
    StoreApi.getAllQuyen()
      .then((response) => {
        if (response.status === 200) {
          const getRole = (code) =>
            response.data.some(
              (e) => e.ModuleCode?.toUpperCase() === code.toUpperCase()
            );
          setPhanQuyen({
            cauhinhtinhlai: getRole(configsRole.sRole.cauhinhtinhlai),
          });
        }
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  React.useEffect(() => {
    if (phanQuyen.cauhinhtinhlai) {
      fetchConfiguration();
    }
  }, [phanQuyen.cauhinhtinhlai]);
  if (loading)
    return (
      <Layout>
        <div className="loading-page1">
          <div className="loader loader-default is-active"></div>
        </div>
      </Layout>
    );

  const scrollWrapperStyle = {
    overflowX: "auto",
    width: "100%",
    paddingBottom: "10px",
  };
  const minWidthStyle = { minWidth: "1000px" };

  return (
    <Layout>
      {phanQuyen.cauhinhtinhlai === true ? (
        <>
          {/* <button className="btn btn-danger btn-w-m btn-sm fixed-bottom-btn" onClick={handleSave} disabled={isSaving}>
                    <i className="fas fa-check"></i> {isSaving ? "Đang cập nhật..." : "Cập nhật"}
                </button> */}

          <div id="form-repeater" className="p-1">
            <div style={{ marginBottom: "5px" }}>
              <div className="row header justify-content-start">
                <img
                  src="/app-assets/images/icon-cau-hinh.png"
                  alt="Mẫu hợp đồng"
                />
                <h1 className="text-info-home mb-1">Cấu hình tính lãi</h1>
              </div>
            </div>
            <div className="card border-light mb-2 card-v2">
              <div className="card-body card-body-v2">
                <div className="tabs-container">
                  <ul className="custom-tabs" id="pills-tab" role="tablist">
                    <li className="custom-tabs__item" role="presentation">
                      <a
                        className={`custom-tabs__link ${
                          activeTab === "camdo" ? "is-active" : ""
                        }`}
                        onClick={(e) => {
                          e.preventDefault();
                          setActiveTab("camdo");
                        }}
                        href="#camdo"
                        role="tab"
                      >
                        Cấu hình Cầm đồ - Tín chấp
                      </a>
                    </li>
                    <li className="custom-tabs__item" role="presentation">
                      <a
                        className={`custom-tabs__link ${
                          activeTab === "tragop" ? "is-active" : ""
                        }`}
                        onClick={(e) => {
                          e.preventDefault();
                          setActiveTab("tragop");
                        }}
                        href="#tragop"
                        role="tab"
                      >
                        Cấu hình Trả góp
                      </a>
                    </li>
                  </ul>
                </div>
                <div className="tab-content px-1 pt-1">
                  <div
                    className={`tab-pane ${
                      activeTab === "camdo" ? "active" : ""
                    }`}
                    id="camdo"
                  >
                    <div style={scrollWrapperStyle}>
                      <div style={minWidthStyle}>
                        {configData && (
                          <CauHinhCamDoTinChap
                            data={configData}
                            handleInputChange={handleInputChange}
                            handleSelectAll={handleSelectAll}
                            CustomCheckbox={CustomCheckbox}
                            CustomRadio={CustomRadio}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                  <div
                    className={`tab-pane ${
                      activeTab === "tragop" ? "active" : ""
                    }`}
                    id="tragop"
                  >
                    <div style={scrollWrapperStyle}>
                      <div style={minWidthStyle}>
                        {configData && (
                          <CauHinhTraGop
                            data={configData}
                            handleInputChange={handleInputChange}
                            CustomCheckbox={CustomCheckbox}
                            CustomRadio={CustomRadio}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="px-1">
                  <div className="last-setting-bh mt-2">
                    <div style={scrollWrapperStyle}>
                      <div
                        className="form-body custom-form-layout"
                        style={minWidthStyle}
                      >
                        <div className="form-group row">
                          <label className="col-md-2 label-control">
                            Cấu hình phí khác
                          </label>
                          <div className="col-md-10 d-flex align-items-center">
                            <div className="d-flex gap-3">
                              <button
                                type="button"
                                className="btn btn-border-new btn-w-m d-flex align-items-center justify-content-center"
                                style={{ marginRight: 8 }}
                                onClick={() =>
                                  showFeeModal(
                                    false,
                                    3,
                                    "Cấu hình phí khác Cầm đồ"
                                  )
                                }
                              >
                                <img
                                  src="/app-assets/images/icon-cam-do-v2.png"
                                  alt="Cầm đồ"
                                  style={{
                                    width: 20,
                                    height: 20,
                                    marginRight: 8,
                                  }}
                                />
                                <span>Cầm đồ</span>
                              </button>
                              <button
                                type="button"
                                className="btn btn-border-new btn-w-m d-flex align-items-center justify-content-center"
                                style={{ marginRight: 8 }}
                                onClick={() =>
                                  showFeeModal(
                                    false,
                                    1,
                                    "Cấu hình phí khác Tín chấp"
                                  )
                                }
                              >
                                <img
                                  src="/app-assets/images/logo-tin-chap-v2.png"
                                  alt="Tín chấp"
                                  style={{
                                    width: 20,
                                    height: 20,
                                    marginRight: 8,
                                  }}
                                />
                                <span>Tín chấp</span>
                              </button>
                              <button
                                type="button"
                                className="btn btn-border-new btn-w-m d-flex align-items-center justify-content-center"
                                style={{ marginRight: 8 }}
                                onClick={() =>
                                  showFeeModal(
                                    false,
                                    2,
                                    "Cấu hình phí khác Trả góp"
                                  )
                                }
                              >
                                <img
                                  src="/app-assets/images/icon-tra-gop-v3.png"
                                  alt="Trả góp"
                                  style={{
                                    width: 20,
                                    height: 20,
                                    marginRight: 8,
                                  }}
                                />
                                <span>Trả góp</span>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {IsSuDungPhiKhacHangKy == true && (
                    <>
                      <div className="last-setting-bh mt-1">
                        <div style={scrollWrapperStyle}>
                          <div
                            className="form-body custom-form-layout"
                            style={minWidthStyle}
                          >
                            <div className="form-group row">
                              <label className="col-md-2 label-control">
                                Cấu hình phí khác hàng kỳ
                              </label>
                              <div className="col-md-10 d-flex align-items-center">
                                <div className="d-flex gap-3">
                                  <button
                                    type="button"
                                    className="btn btn-border-new btn-w-m d-flex align-items-center justify-content-center"
                                    style={{ marginRight: 8 }}
                                    onClick={() =>
                                      showFeeModal(
                                        true,
                                        3,
                                        "Cấu hình phí khác hàng kỳ Cầm đồ"
                                      )
                                    }
                                  >
                                    <img
                                      src="/app-assets/images/icon-cam-do-v2.png"
                                      alt="Cầm đồ"
                                      style={{
                                        width: 20,
                                        height: 20,
                                        marginRight: 8,
                                      }}
                                    />
                                    <span>Cầm đồ</span>
                                  </button>
                                  <button
                                    type="button"
                                    className="btn btn-border-new btn-w-m d-flex align-items-center justify-content-center"
                                    style={{ marginRight: 8 }}
                                    onClick={() =>
                                      showFeeModal(
                                        true,
                                        1,
                                        "Cấu hình phí khác hàng kỳ Tín chấp"
                                      )
                                    }
                                  >
                                    <img
                                      src="/app-assets/images/logo-tin-chap-v2.png"
                                      alt="Tín chấp"
                                      style={{
                                        width: 20,
                                        height: 20,
                                        marginRight: 8,
                                      }}
                                    />
                                    <span>Tín chấp</span>
                                  </button>
                                  <button
                                    type="button"
                                    className="btn btn-border-new btn-w-m d-flex align-items-center justify-content-center"
                                    style={{ marginRight: 8 }}
                                    onClick={() =>
                                      showFeeModal(
                                        true,
                                        2,
                                        "Cấu hình phí khác hàng kỳ Trả góp"
                                      )
                                    }
                                  >
                                    <img
                                      src="/app-assets/images/icon-tra-gop-v3.png"
                                      alt="Trả góp"
                                      style={{
                                        width: 20,
                                        height: 20,
                                        marginRight: 8,
                                      }}
                                    />
                                    <span>Trả góp</span>
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>{" "}
                    </>
                  )}
                </div>
                {!modalState.show && (
                  <div
                    className="sticky-bottom"
                    style={{
                      position: "fixed",
                      bottom: 32,
                      left: 264,
                      right: 14,
                      zIndex: 9999,
                    }}
                  >
                    <div className="card border-light show-table-main card-v2">
                      <div
                        className="card-body card-body-v2"
                        style={{ padding: "12px 16px" }}
                      >
                        <div className="d-flex justify-content-end">
                          <button
                            className="btn btn-danger btn-w-m btn-sm "
                            onClick={handleSave}
                            disabled={isSaving}
                          >
                            <i className="fas fa-check"></i>{" "}
                            {isSaving ? "Đang cập nhật..." : "Cập nhật"}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
          {modalState.show && (
            <QuanLyPhiKhacModal
              show={modalState.show}
              onHide={() => setModalState({ ...modalState, show: false })}
              isPeriodic={modalState.isPeriodic}
              loanType={modalState.loanType}
              title={modalState.title}
              CustomCheckbox={CustomCheckbox}
            />
          )}
        </>
      ) : (
        <div id="form-repeater" className="p-1">
          <div className="d-flex align-items-center">
            <i
              className="fa-solid fa-gear fa-3x"
              style={{ color: "#1cc88a" }}
            ></i>
            <h1 className="text-info-home mb-0 ms-2 fw-bold">
              Cấu hình tính lãi
            </h1>
          </div>
          <span
            style={{
              textAlign: "center",
              color: "red",
              display: "flex",
              justifyContent: "center",
              marginTop: "20px",
            }}
          >
            Bạn không có quyền truy cập chức năng này.
          </span>
        </div>
      )}
    </Layout>
  );
};
